<template>
  <v-card
    v-if="!closed"
    flat
    class="background-card d-flex align-center position-relative"
  >
    <div class="flex-grow-1">
      <span>
        <v-tag class="mb-2">
          {{ $t('message.pages.analyticsV3.resume.mobile.title') }}
        </v-tag>
      </span>
      <p class="body-bold-large brand-0--text mb-1">
        {{ $t('message.pages.analyticsV3.resume.mobile.description') }}
      </p>

      <p class="neutral-40-light--text mt-4 text-break">
        {{ $t('message.pages.analyticsV3.resume.mobile.tip') }}
      </p>

      <div>
        <base-btn type="neutral" @click="goToLink($t('message.pages.analyticsV3.resume.mobile.link'))">
            {{ $t('message.pages.analyticsV3.resume.mobile.learnMore') }}
            <v-icon size="20" class="ml-1">mdi-open-in-new</v-icon>
        </base-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'MobileBanner',
  data() {
    return {
      closed: false,
    }
  },
  methods: {
    goToLink(link) {
      window.open(link, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.background-card {
  padding: 16px;
  gap: 40px;
  border-radius: 8px;
  background: varFigma(neutral-95-lightest) !important;
  position: relative;
}
</style>
